import eventMetaMap from '../../../constants/slEventBusEventNames';
import cartFunctions from './cartFunctions';

export default {
  functions: [
    ...cartFunctions,
    {
      name: 'getPDPProduct',
      type: 'angularData',
      options: {
        source: 'appExtensionSdkData',
        key: 'pdpProduct',
      },
    },
  ],
  events: [
    {
      incomingEvent: eventMetaMap.pdp.variationChanged,
      sdkEvent: 'page.variationChanged',
      // replay page-load selection to late listeners (DC-4510)
      sticky: true,
    },
    {
      incomingEvent: eventMetaMap.pdp.quantityChanged,
      sdkEvent: 'page.quantityChanged',
      // querystring variant_id=xxxx is used to pre-select a variation on page load, so we need to replay the event to late listeners (SL-52591)
      sticky: true,
    },
    {
      incomingEvent: eventMetaMap.pdp.addonQuantityChanged,
      sdkEvent: 'page.addonQuantityChanged',
    },
  ],
};
